module.exports = __webpack_public_path__ + "static/11-4c41e06a78a8fabf629572ce6b687b0f.jpg";